import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddCertifications, Certifications } from '../models/certifications/certifications';


@Injectable({
  providedIn: 'root'
})
export class CertificationsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getCertifications(CertificationsId?: number): Observable<Certifications[]>{
        return this._http.get<Certifications[]>(`${environment.api.url}/Certifications?CertificationsId=${CertificationsId??''}`);
    }
  
    public deleteCertifications(CertificationsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Certifications/${CertificationsId}`);
    }
  
    public addCertifications(model: AddCertifications): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Certifications`, model);
    }
}
